import { render, staticRenderFns } from "./detail-optimized.vue?vue&type=template&id=3cf06429&scoped=true&"
import script from "./detail-optimized.vue?vue&type=script&lang=ts&"
export * from "./detail-optimized.vue?vue&type=script&lang=ts&"
import style0 from "./detail-optimized.vue?vue&type=style&index=0&id=3cf06429&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf06429",
  null
  
)

export default component.exports